/**
 * DEV-1225. Единая шапка проекта: вкладка «Редактирование» и подтверждение
 * ухода с несохранённой формы. Подмешивается поверх базовых локалей.
 */
export const propertyEditTabMessages = {
  ru: {
    properties: {
      tabs: { edit: 'Редактирование' },
      form: { leaveConfirm: 'Изменения не сохранены. Уйти со страницы?' },
    },
  },
  en: {
    properties: {
      tabs: { edit: 'Edit' },
      form: { leaveConfirm: 'You have unsaved changes. Leave the page?' },
    },
  },
  vn: {
    properties: {
      tabs: { edit: 'Chỉnh sửa' },
      form: { leaveConfirm: 'Thay đổi chưa được lưu. Rời khỏi trang?' },
    },
  },
}
